import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';

export default function FadeLoading({ loading, loadingTexts = [], onTick }) {
    const { t } = useTranslation();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showingLoading, setShowingLoading] = useState(false);
    const [isFading, setIsFading] = useState(false);

    useEffect(() => {
        let timer;
        if (loading) {
            setShowingLoading(true);
            onTick(false);
        }
        if (showingLoading)
            if (currentIndex < loadingTexts.length - 1) {
                timer = setTimeout(() => {
                    setIsFading(true);

                    setTimeout(() => {
                        setCurrentIndex((prevIndex) => prevIndex + 1);
                        setIsFading(false);
                    }, 200);
                }, 1000);
            } else {
                const intervalId = setInterval(() => {
                    if (!loading) {
                        clearInterval(intervalId);
                        setShowingLoading(false);
                        setCurrentIndex(0);
                        setIsFading(false);
                        onTick(true);
                    }
                }, 1200);

                return () => clearInterval(intervalId);
            }

        return () => clearTimeout(timer);
    }, [loading, currentIndex]);

    return (
        <>
            {showingLoading && (
                <Stack
                    direction="row"
                    sx={{ background: '#EBEBFF', borderRadius: 2, padding: 2 }}
                    spacing={2}
                    alignItems="center"
                >
                    <CircularProgress size="24px" />
                    <Typography
                        variant="caption"
                        fontWeight={400}
                        className={`fade ${isFading ? 'fade-exit-active' : 'fade-enter-active'}`}
                    >
                        {t(loadingTexts[currentIndex])}
                    </Typography>
                </Stack>
            )}
        </>
    );
}
